import React from "react"
import { connect } from "react-redux"
import { userResetPassword } from "../../../../Actions/Auth/AuthActions"
import { MainThunkDispatch } from "../../../../Reducers"
import { safePromise } from "../../../../Helpers/Functions/promise"
import { SingleLineTextInput, Button } from "dash-styled"
import { useInput } from "../../../../Hooks/useInput"

interface ResetPasswordFormProps {
    onSubmit: () => void
}

interface StateProps {}

interface DispatchProps {
    userResetPasswordForm: (
        emailAddress: string,
        code: string,
        newPassword: string,
        result: () => void
    ) => void
}

export type Props = ResetPasswordFormProps & StateProps & DispatchProps

export const ResetPasswordFormIsolated = ({
    userResetPasswordForm,
    onSubmit
}: Props) => {
    const email = useInput("", false)
    const code = useInput("", false)
    const password = useInput("", false)
    const handleSubmit = () =>
        userResetPasswordForm(email.value, code.value, password.value, onSubmit)
    const isValid = email.isValid && code.isValid && password.isValid

    return (
        <div className="flex flex-col items-stretch px-4">
            <SingleLineTextInput
                name="email"
                type="email"
                autoComplete="off"
                label="Email"
                value={email.value}
                onChange={email.onChange}
                placeholder="me@company.com"
                className="pb-4"
                testId="reset-email"
            />
            <SingleLineTextInput
                name="code"
                type="password"
                autoComplete="off"
                label="Code"
                value={code.value}
                onChange={code.onChange}
                className="pb-4"
                testId="reset-code"
            />
            <SingleLineTextInput
                name="password"
                autoComplete="off"
                label="New Password"
                type="password"
                value={password.value}
                onChange={password.onChange}
                className="pb-4"
                testId="reset-password"
            />
            <Button
                onClick={handleSubmit}
                disabled={!isValid}
                className="mt-4 w-64 mx-auto"
                testId="reset-submit"
            >
                Reset password
            </Button>
        </div>
    )
}

const mapDispatchToProps = (dispatch: MainThunkDispatch): DispatchProps => {
    return {
        userResetPasswordForm: async (
            username: string,
            code: string,
            newPassword: string,
            onSuccess: () => void
        ) => {
            const { error } = await safePromise(
                dispatch(userResetPassword(username, code, newPassword))
            )

            if (error === undefined) {
                onSuccess()
            }
        }
    }
}

export const ResetPasswordForm = connect(
    null,
    mapDispatchToProps
)(ResetPasswordFormIsolated)
